<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2>
      <v-container fluid class="scroll-y" style="max-height: 400px" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-layout row wrap>
          <v-flex
            v-for="(item, index) in users"
            :key="item._id"
            xs4
            mb-4
            @click="goToUser(item._screen_name)"
            style="cursor: pointer"
          >
            <v-badge color="transparent" tile>
              <v-avatar>
                <img :id="index" :src="item._profile_image_url_https" @error="alternateImg(index)">
              </v-avatar>
              <span slot="badge" class="caption accent--text pl-3" size="30">{{numberOfFollowers(item._followers_count)}}</span>
            </v-badge>
            <v-tooltip top>
              <v-avatar size="30" slot="activator" @click.stop="filterByUser(item._screen_name)">
                <v-icon class="btnHoverClass" style="border-radius: 100%">filter_list</v-icon>
              </v-avatar>
              <span>Filter by user</span>
            </v-tooltip>
            <v-card flat tile style="min-height: 40px">
              <p class='ma-0' style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{item._name}}</p>
              <v-layout row style="width: 100%; align-items: center; justify-content: center">
                <p class='ma-0 caption' style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{'@' + item._screen_name}}</p>
                <v-tooltip top>
                  <v-avatar size="30" slot="activator" @click.stop="selectedUser = item._id; deleteUserConfirmationDialog = true">
                    <v-icon class="btnHoverClass" style="border-radius: 100%" size="15">fas fa-trash</v-icon>
                  </v-avatar>
                  <span>Delete user</span>
                </v-tooltip>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
    </v-flex>
    <v-dialog
      v-model="deleteUserConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete user?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteUser" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteUserConfirmationDialog = false; selectedUser = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>
.btnHoverClass:hover{background-color: #E0E0E0}
.alternateState{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.blurClass{
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
</style>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      users: [],
      deleteUserConfirmationDialog: false,
      selectedUser: null,
      deleteLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters']),
    deleteUser () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteUserById', {id: this.selectedUser, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedUser = null
          this.deleteUserConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    goToUser (name) {
      window.open('https://twitter.com/' + name, '_blank')
    },
    filterByUser (userName) {
      this.setCustomFilters({screenName: userName})
    },
    alternateImg: function (index) {
      this.users[index]._profile_image_url_https = 'https://abs.twimg.com/sticky/default_profile_images/default_profile.png'
    },
    numberOfFollowers: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTwitterContributors', this.getQuery({sortBy: '_followers_count', order: 'desc', pageSize: 30}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.users = r1.data.payload
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
          } else {
            this.dataState = 'noData'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/rankings/ContributorsByNumberOfFollowers.vue